import React, { useEffect, useState } from 'react'
import { isInstitutional } from '../../../global/authentication/authentication-manager'
import {
  BrPageContext,
  BrManageMenuButton,
  BrComponentContext,
} from '@bloomreach/react-sdk'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/config/environments.js'

const FooterNav = () => {
  const component = React.useContext(BrComponentContext)
  const page = React.useContext(BrPageContext)

  const [menu, setMenu] = useState(null)
  useEffect(() => {
    const _menuRef = component?.getModels().menu
    const _menu = _menuRef && page?.getContent(_menuRef)
    if (_menu) {
      setMenu(_menu)
    }
  }, [])

  return menu ? (
    <div className="Grid Grid--withGutter u-sizeConstrained u-sm-hidden">
      <div className="Footer-nav Footer-nav-spa Grid u-flexJustifyBetween u-padding0 u-margin0 u-posRelative">
        <BrManageMenuButton menu={menu} />
        {menu?.getItems().map((item) => {
          const childItems = item.getChildren()
          return (
            <div
              key={item.getName()}
              className="u-marginTop2gu u-md-size1of5 u-lg-size1of5 u-paddingRight4gu"
            >
              <h4>
                {isInstitutional() ? (
                  <span className="Link LinkList-header ignore-click">
                    {item.getName()}
                  </span>
                ) : (
                  <a
                    className="Link LinkList-header"
                    href={item.getLink().href}
                  >
                    {item.getName()}
                  </a>
                )}
              </h4>
              {childItems.length ? (
                <ul
                  className="LinkList-items"
                  data-qa-automation="footer-menu-navigation-level1"
                >
                  {childItems.map((subitem) => (
                    <li key={subitem.getName()}>
                      <a
                        className="Link LinkList-item u-textSizeMsrm1 u-block"
                        href={subitem.getLink().href}
                      >
                        {subitem.getName()}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          )
        })}
      </div>
    </div>
  ) : null
}

export default function ErrorWrapperFooterNav(props) {
  return (
    <ErrorBoundary
      fallback={() =>
        !isProduction() ? <p>Erorr in FooterNav component</p> : null
      }
    >
      <FooterNav {...props}></FooterNav>
    </ErrorBoundary>
  )
}
